import { ContainmentInstance } from '@/shared/Containment';

export default defineNuxtPlugin({
  name: 'containment',

  setup() {
    const containmentInstance = ContainmentInstance.getInstance();

    const { getValidationModule, isValidationModuleEnabled } =
      useModulesValidation();

    function debugWithIcon(moduleName: keyof ValidationModules) {
      const icon = isValidationModuleEnabled(moduleName) ? '🟢' : '🔴';

      return `\n ${icon} ${moduleName}`;
    }

    const { $debug } = useNuxtApp();

    if ($debug.isEnabled) {
      console.debug(
        `\n ⚪ Validation Modules:`,
        debugWithIcon('global'),
        getValidationModule('global'),
        debugWithIcon('register'),
        getValidationModule('register'),
        debugWithIcon('first_deposit'),
        getValidationModule('first_deposit'),
        debugWithIcon('deposit'),
        getValidationModule('deposit'),
        debugWithIcon('first_withdraw'),
        getValidationModule('first_withdraw'),
        debugWithIcon('withdraw'),
        getValidationModule('withdraw'),
        debugWithIcon('casino'),
        getValidationModule('casino'),
        debugWithIcon('sports'),
        getValidationModule('sports'),
        debugWithIcon('validation_code_sms'),
        getValidationModule('validation_code_sms'),
        debugWithIcon('update_data'),
        getValidationModule('update_data'),
        debugWithIcon('update_limits'),
        getValidationModule('update_limits'),
        `\n ⚪ End modules \n `,
      );
    }

    containmentInstance.updateConfig({
      global: getValidationModule('global'),
      register: getValidationModule('register'),
      first_deposit: getValidationModule('first_deposit'),
      deposit: getValidationModule('deposit'),
      first_withdraw: getValidationModule('first_withdraw'),
      withdraw: getValidationModule('withdraw'),
      casino: getValidationModule('casino'),
      sports: getValidationModule('sports'),
      validation_code_sms: getValidationModule('validation_code_sms'),
      update_data: getValidationModule('update_data'),
      update_limits: getValidationModule('update_limits'),
    });

    const { isKycForcedRequest } = useUserData();

    if (isKycForcedRequest.value) {
      containmentInstance.updateConfig({
        global: [
          {
            name: 'kyc',
            frequent: false,
          },
          ...getValidationModule('global'),
        ],
      });
    } else {
      containmentInstance.updateConfig({
        global: getValidationModule('global'),
      });
    }

    return {
      provide: {
        containment: containmentInstance,
      },
    };
  },
});
